import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppReportingChannelService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppReportingChannels`);
    }
}